import { useCallback } from 'react';

export interface IUseOnSuggestionInputBlur {
  clearSuggestValue(): void;

  clearSuggestionData(): void;
}
export const useGeoTagsInputBlur = ({ clearSuggestValue, clearSuggestionData }: IUseOnSuggestionInputBlur) => {
  return useCallback(() => {
    clearSuggestValue();
    clearSuggestionData();
  }, [clearSuggestValue, clearSuggestionData]);
};
